<template>
  <GeminiScrollbar style="  width: 100%;">
    <div class="container_ShopList">
      <main id="main" ref="main">
        <template v-if="set_base.cate_order">
          <template v-if="choosefl === -1">
            <section v-for="(shop, index) in newGoods" :key="index">
              <!-- <h1>{{ shop.title }}</h1> -->
              <ul>
                <li v-for="(item, index) in shop" :key="index" @click="jumpF(item.id, mobile)">
                  <!-- @click="$root.jump('order', urlQueryName, 'id', item.id, 'mobile', mobile)" -->
                  <section>
                    <div>
                      <img class="avatar" :src="$root.tomedia(item.thumb)" alt />
                      <div class="saleout" v-if="item.stock === '0'"></div>
                    </div>
                    <div class="title">{{ item.title }}</div>
                    <div class="recharge">
                      {{ item.type == 0 ? "自动发货" : "" }}
                      {{ item.is_api == 1 && item.type == 1 ? "自动充值" : "" }}
                      {{ item.is_api == 0 && item.type == 1 ? "商家代充" : "" }}
                    </div>
                    <div class="value">
                      <span
                        class="agency_price"
                        v-if="set_base.agency_price_display === 1  && (item.original_price !== '0.00') "
                      >原价:{{item.original_price}}</span>
                      <span class="price">{{ item.price }}</span>
                      <span class="num">库存：{{ item.stock }}</span>
                    </div>
                    <div>
                      <button class="buy_btn">购买</button>
                    </div>
                  </section>
                </li>
              </ul>
            </section>
          </template>
          <template v-else>
            <section>
              <ul>
                <li v-for="(item, index) in newGoods" :key="index" @click="jumpF(item.id, mobile)">
                  <section>
                    <div>
                      <img class="avatar" :src="$root.tomedia(item.thumb)" alt />
                      <div class="saleout" v-if="item.stock === '0'"></div>
                    </div>
                    <div class="title">{{ item.title }}</div>
                    <div class="recharge">
                      {{ item.type == 0 ? "自动发货" : "" }}
                      {{ item.is_api == 1 && item.type == 1 ? "自动充值" : "" }}
                      {{ item.is_api == 0 && item.type == 1 ? "商家代充" : "" }}
                    </div>
                    <div class="value">
                      <span class="price">{{ item.price }}</span>
                      <span class="num">库存：{{ item.stock }}</span>
                    </div>
                    <div>
                      <button class="buy_btn">购买</button>
                    </div>
                  </section>
                </li>
              </ul>
            </section>
          </template>
        </template>
      </main>
    </div>
  </GeminiScrollbar>
</template>

<script>
import getData from '@/utils/getData'
import { getUrlUserInfo } from '@/common/common' // 获取url的参数

export default {
  data() {
    return {
      urlQueryName: null
    }
  },
  props: {
    set_base: {
      type: Object,
      required: false
    },
    category: {
      type: Array,
      required: false
    },
    newGoods: {
      type: Array,
      required: false
    },
    mobile: {
      type: String,
      required: false
    },
    choosefl: {
      type: Number,
      required: false
    }
  },
  components: {},
  computed: {},
  watch: {},
  methods: {
    // type your function
    async getStyle() {
      let name = await getUrlUserInfo(this.$route.fullPath) // sup 或者 mid
      this.urlQueryName = name
      let style = await getData.getShopStyle(name, this.$route.query[name])
    },
    jumpF(id, mobile) {
      this.$router.push({
        path: 'order',
        query: {
          [this.urlQueryName]: this.$route.query[this.urlQueryName],
          id,
          mobile
        }
      })
    }
  },
  created() {
    this.getStyle()
  },
  mounted() {},
  updated() {},
  destroyed() {},
  filters: {}
}
</script>

<style scoped lang="less">
@import '../../common/Less/index';
.container_ShopList {
  // width: 620px;
  width: 100%;
  overflow-y: auto;
  ul {
    .mixin_zero();
    li {
      margin-bottom: 8px;
      list-style: none;
      section {
        // .mixin_wh(620px, 80px);
        .mixin_wh(100%, 80px);
        background: @white;
        cursor: pointer;

        .mixin_flex(row, wrap, space-between, center);
        div {
          position: relative;

          .avatar {
            .mixin_square(80px);
            // background: @black;

            margin-left: 19px;
          }
          .saleout {
            .mixin_square(80px);
            position: absolute;
            top: 0;
            left: 20px;
            background: url(../../../static/image/SALEOUT.png);
            background-size: 80% 80%;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
        .title {
          .mixin_cs(#505050, 2);
          // min-width: 200px;
          width: 448px;
          overflow: hidden;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .recharge {
          .mixin_cs(#2a9aec, 6);
          height: 11px;
          width: 60px;
          word-break: keep-all;
        }
        .value {
          .mixin_flex(column, wrap, '', center);
          width: 100px;
          .agency_price {
            color: gray;
            font-size: 12px;
            text-decoration: line-through;
          }
          .price {
            color: #c21e1e;
            font-size: @fontSize - 2;
            margin-bottom: 4px;
            &::before {
              content: '￥';
              .mixin_size(3);
            }
          }
          .num {
            font-size: @fontSize - 4;
          }
        }
        .buy_btn {
          .mixin_wh(80px, 29px);
          .mixin_cb(@white, @blue);
          border: none;
          letter-spacing: @spacing;

          margin-right: 34px;
          cursor: pointer;
        }
      }
    }
  }
}
// .container_ShopList::-webkit-scrollbar {
//   /*滚动条整体样式*/
//   width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
//   height: 4px;
// }
// .container_ShopList::-webkit-scrollbar-thumb {
//   /*滚动条里面小方块*/
//   border-radius: 5px;
//   -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//   background: #1a92ed83;
// }
// .container_ShopList::-webkit-scrollbar-track {
//   /*滚动条里面轨道*/
//   -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//   border-radius: 0;
//   background: @borderColor;
// }
</style>



// WEBPACK FOOTER //
// src/components/Shop/ShopList.vue